import { render, staticRenderFns } from "./DebugNotifications.vue?vue&type=template&id=52858889&scoped=true"
import script from "./DebugNotifications.vue?vue&type=script&lang=js"
export * from "./DebugNotifications.vue?vue&type=script&lang=js"
import style0 from "./DebugNotifications.vue?vue&type=style&index=0&id=52858889&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52858889",
  null
  
)

export default component.exports